import React from 'react';
import { Container, Store } from 'AppReact';
import { SolidButton } from '../../../../common/molecules';
import { OutlinedButton } from 'molecules';
import { Description } from '../../../../common/atoms';
import { GenericWrapper } from 'wrappers';
import { ButtonsWrapper } from './wrappers';

const ModalBody = Container({
  name: 'ModalBody',
  props: { property: Store, cardDetails: Store, paidFee: Store, occupants: Store },
  renderIf: ({ property }) => !!Object.keys(property).length,
  elements: [
    {
      wrapper: GenericWrapper,
      name: 'Container',
      elements: [
        {
          component: Description,
          name: 'Description',
          bindings: ({ }) => ({}),
          displayValue: ({ property }) => property?.agreement_text || '',
        },
        {
          wrapper: ButtonsWrapper,
          name: 'Buttons',
          elements: [
            {
              component: SolidButton,
              name: 'Accept',
              bindings: ({ cardDetails, property, paidFee, occupants }) => {
                return ({ occupants, paidFee, cardDetails, property, title: "Agree", big: true, })
              },
            },
            {
              component: OutlinedButton,
              name: 'Cancel',
              bindings: () => ({ title: "Cancel" }),
              displayValue: ({ }) => ({ big: true })
            },
          ]
        },
      ]
    },
  ]
})

export default ModalBody
